module.exports = __webpack_public_path__ + "media/images/advisor/img_6_3-eda1500cc3d13fb2630c0fd0ad8a3a18.png";